export default function ConvertHTMLToText({ html, length }) {
  //var stripedHtml = html.replace(/<[^>]+>/g, '');
  var stripedHtml = html.replace(/<\/?[^>]+(>|$)/g, "");
  return stripedHtml.substr(0, length) + "...";
  /* console.log(html);
  const tempDivElement = document.createElement("div");
  tempDivElement.innerHTML = html;
  return tempDivElement.textContent.substr(0, length) + "..." || tempDivElement.innerText.substr(0, length) + "..." || ""; */

};